import styled from "styled-components";
import { V3HeadlineH3 } from "../../Typography";

export const SourceAddedHeadline = styled(V3HeadlineH3)`
    color: ${({ theme }) => theme.v3.colors.grey35};
`;

export const SourceAddedSVG = styled.svg`
    max-width: 252px;
    display: block;
    margin: 0 auto;
`;

export const SourceAddedPanel = styled.div`
    text-align: left;
`;